import './initLog'
import encrypt from '../../utils/encrypt'
import './CCJSAPI'

// CCJSAPI
const timestamp = Date.parse(new Date())
const signature = encrypt.md5('ccbnative_api_' + timestamp)
CCJSAPI.config(timestamp, signature)
